import {CreditCard} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import Subscription from './Subscription';
import SubscriptionError from './SubscriptionError';
import SubscriptionSuccess from './SubscriptionSuccess';

export const subscription: FeatureObject = {
  type: 'settings',
  title: 'Subscription',
  description: 'Manage your subscription',
  IconComponent: CreditCard,
  path: '/subscription',
  component: (user) => <Subscription user={user} />,
  status: FeatureStatus.PROD,
  tags: ['subscription'],
};

export const subscriptionSuccess: FeatureObject = {
  type: 'settings',
  title: 'Subscription',
  description: 'Subscription success',
  IconComponent: CreditCard,
  path: '/subscription/success',
  component: () => <SubscriptionSuccess />,
  status: FeatureStatus.PROD,
  tags: ['skipMenu', 'subscription'],
};

export const subscriptionError: FeatureObject = {
  type: 'settings',
  title: 'Subscription',
  description: 'Subscription failed',
  IconComponent: CreditCard,
  path: '/subscription/failed',
  component: () => <SubscriptionError />,
  status: FeatureStatus.PROD,
  tags: ['skipMenu', 'subscription'],
};
